import { App, Button, Col, Row, Space, Tooltip, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { FaPause, FaPlay } from "react-icons/fa6";
import { Input } from "antd";
import TriggerInit from "./trigger/trigger_init";
import { useSelector } from "react-redux";
import {
  draftDialogDetailSelector,
  draftDialogPlaySelector,
  draftDialogSecondSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
import { useDispatch } from "react-redux";
import {
  setDraftDialogEditCard,
  setDraftDialogKick,
  setDraftDialogPlay,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import moment from "moment";
import { useDialogQC } from "hook/draft/dialog/useDialogsQC";
import { refineSpecificTimer } from "util/refine_timer.function";

//
//component
//redux
//selector
//actions
//utils
//hook
//str

const { TextArea } = Input;
const CardDraftSegmentDebug = ({ data }) => {
  // -------------------------- VAR -----------------------------
  const { loading, handleUpdateSegment } = useDialogQC();
  const { message } = App?.useApp();
  const speaker = data.speaker;
  const text = data?.text;
  const start = data?.start;
  const end = data?.end;
  const from = data?.from;
  const to = data?.to;
  const slot = data?.slot;
  const labelStart = refineSpecificTimer({ timer: start });
  const labelEnd = refineSpecificTimer({ timer: end });
  const labelFrom = refineSpecificTimer({ timer: from });
  const labelTo = refineSpecificTimer({ timer: to });
  const duration = `${labelStart} - ${labelEnd}`;
  const duration2 = `${labelFrom} - ${labelTo}`;
  // -------------------------- STATE ---------------------------
  const [edit, setEdit] = useState(false);
  const [content, setContent] = useState("");
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const dialog = useSelector(draftDialogDetailSelector);
  const second = useSelector(draftDialogSecondSelector);
  const play = useSelector(draftDialogPlaySelector);
  const isPlaySecond = second >= start && second <= end;
  const isPlay = isPlaySecond && play;
  const rated = dialog?.rated || false;
  const classBg = isPlaySecond ? "bg-yellow-200" : "";

  // -------------------------- FUNCTION ------------------------
  const togglePlay = () => {
    if (start === null) return message.error("Dữ liệu không tìm thấy!");
    const id = `change-${moment()?.valueOf()}-${start}`;
    dispatch(setDraftDialogPlay(!play));
    dispatch(setDraftDialogKick(id));
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setContent(value);
  };

  const handleSave = () => {
    return handleUpdateSegment({ slot, content, start, end, speaker, setEdit });
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(setDraftDialogEditCard(edit));
  }, [edit, dispatch]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderSpeaker = () => {
    return <b style={{ fontSize: 16 }}>Người nói: {speaker}</b>;
  };

  const renderPlay = () => {
    return (
      <Tooltip title="Nghe lại đoạn hội thoại">
        <Button
          onClick={togglePlay}
          shape="circle"
          type="text"
          icon={
            <span className="anticon">
              {!isPlay ? <FaPlay /> : <FaPause />}
            </span>
          }
        />
      </Tooltip>
    );
  };

  const renderTextArea = () => {
    return <p className={classBg}>{data?.fix || data?.text}</p>;
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Row
      gap={[20, 20]}
      style={{
        display: "flex",
        alignItems: "center",
        borderTop: "0.5px solid rgba(0,0,0,0.1)",
        paddingTop: 10,
      }}
    >
      <Col xl={24} lg={24} md={24} xs={24}>
        <div className="flex flex-row items-center gap-1">
          {renderSpeaker()} {renderPlay()}
        </div>
      </Col>
      <Col className="my-2" xl={24} lg={24} md={24} xs={24}>
        <div className="flex flex-col gap-2">
          <span style={{ color: "#aeaeae" }}>
            (Start - End) {duration} (Dùng cho Supporter, Operator)
          </span>
          <span style={{ color: "#aeaeae" }}>
            (From - To) {duration2} (Dùng cho Client)
          </span>
        </div>
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderTextArea()}
      </Col>
      <TriggerInit text={text} setContent={setContent} />
    </Row>
  );
};
export default CardDraftSegmentDebug;
